import image1 from '../assets/gallery/1.webp'
import image2 from '../assets/gallery/2.webp'
import image3 from '../assets/gallery/3.webp'
import image4 from '../assets/gallery/4.webp'
import image5 from '../assets/gallery/5.webp'
import image6 from '../assets/gallery/6.webp'
import image7 from '../assets/gallery/7.webp'
import image8 from '../assets/gallery/8.webp'
import image9 from '../assets/gallery/9.webp'
import image10 from '../assets/gallery/10.webp'
import image11 from '../assets/gallery/11.webp'
import image12 from '../assets/gallery/12.webp'
import image14 from '../assets/gallery/14.webp'
import image15 from '../assets/gallery/15.webp'
import image17 from '../assets/gallery/17.webp'
import image18 from '../assets/gallery/18.webp'
import image19 from '../assets/gallery/19.webp'
import image20 from '../assets/gallery/20.webp'
import image21 from '../assets/gallery/21.webp'
import image22 from '../assets/gallery/22.webp'
import image23 from '../assets/gallery/23.webp'
import image24 from '../assets/gallery/24.webp'
import image25 from '../assets/gallery/25.webp'
import image26 from '../assets/gallery/26.webp'
import image27 from '../assets/gallery/27.webp'
import image28 from '../assets/gallery/28.webp'
import image29 from '../assets/home-carousel.jpeg'

const gallery_images = [
    {
        "src": image14,
        "description": "IIT Delhi proudly hosted the US National Security Advisor, Mr JakeSullivan, for a Special Address on 'The United States and India: Buildinga Shared Future.'"
    },
    {
        "src": image15,
        "description": "IIT Delhi had the honor of hosting Mr. Amandeep Singh Gill, UN Under-Secretary-General for Digital & Emerging Technologies, for an inspiring discussion on 'UN@80: New Direction for Technology Governance.'"
    },
    {
        "src": image17,
        "description": "Ms. Jaya Jagadish, Country Head & SVP, Silicon Design Engineering at AMD India Private Limited, for an exclusive Tête-à-tête on 67th Foundation Day of IIT Delhi"
    },
    {
        "src": image18,
        "description": "Commemorating the 67th Foundation Day of IIT Delhi"
    },
    {
        "src": image19,
        "description": "IIT Delhi had the incredible honor of hosting Mr. Cameron Adams, Co-founder & Chief Product Officer of @Canva! His journey from a designer to a global tech leader has reshaped the way millions create and communicate visually."
    },
    {
        "src": image20,
    },
    {
        "src": image29,
    },
    {
        "src": image21,
        "description": "Empowering Women, Empowering Change Celebrating the spirit of International Women’s Day at IIT Delhi!"
    },
    {
        "src": image22,
        "description": "STEM Mentorship Program Winter Phase"
    },
    {
        "src": image23,
    },
    {
        "src": image24,
        "description": "STS Lecture"
    },
    {
        "src": image25,
        "description": "Ompee Internation School, Gurgaon Students Visit"
    },
    {
        "src": image26,
        "description": "Japanese Delegates Visit"
    },
    {
        "src": image27,
        "description": "Indian Army School Students Visit"
    },
    {
        "src": image28,
        "description": "Indian Army School Students Visit"
    },
    {
        "src": image4,
    },
    {
        "src": image5,
    },
    {
        "src": image9,
    },
]

export default gallery_images;